import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class DepartmentService {
  static loadDepartments() {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENTS}`;
    return axios.get(url).then((response) => response.data);
  }

  static getDepartment(id) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENTS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static findByCode(code) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENTS}/search-code?code=${code}`;
    return axios.get(url).then((res) => res.data);
  }

  static updateDepartment(id, department) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENTS}/${id}`;
    const body = {
      department
    };

    return axios.put(url, body).then((response) => response.data);
  }
}

export default DepartmentService;
